import React from "react";
import { styled } from "@linaria/react";
import type { StatusDisplay } from "./utils";
import { STATUS_COLORS } from "./utils";
import { fonts } from "@ui";
import { CheckboxBlankCircleFill } from "@ui/IconV2/react";

interface P {
  status: StatusDisplay;
  label: string;
}

const LabelledHintRoot = styled.div<{ status: StatusDisplay }>`
  align-items: center;
  display: flex;
  font: ${fonts.body1};
  gap: 8px;

  svg {
    height: 8px;
    width: 8px;
    transform: translateY(0.5px);

    path {
      fill: ${props => STATUS_COLORS[props.status]};
    }
  }
`;

function LabelledHint({ status, label }: P) {
  return (
    <LabelledHintRoot status={status}>
      <CheckboxBlankCircleFill size="xxs" />
      {label}
    </LabelledHintRoot>
  );
}

export default React.memo(LabelledHint);
